import { useMutation } from "urql";

import { UpdateCustomerDirectorInfoDocument } from "../../../graphql/generated.ts";

export const useUpdateCustomerDirectorInfo = () =>
  useMutation(UpdateCustomerDirectorInfoDocument);
